export default "__VITE_ASSET__e2BqqElL__"